import { render } from "./ContactInfo.vue?vue&type=template&id=498164bf&scoped=true"
import script from "./ContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactInfo.vue?vue&type=script&lang=js"

import "./ContactInfo.vue?vue&type=style&index=0&id=498164bf&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c77b6d3d/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498164bf"]])

export default __exports__